var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-geo-json',{attrs:{"geojson":_vm.radarLine,"options":_vm.options,"pane":"radarPane"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }